import { useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { reorder, move, getItemStyle, getListStyle } from '../tools'

export const Baskets = ({
  title = 'Put these numbers in order from <b>least</b> to <b>greatest</b>',
  items: pItems = [],
  baskets: pBaskets = [],
}) => {
  const [baskets, setBaskets] = useState([])
  const [items, setItems] = useState({})

  useEffect(() => {
    setBaskets(pBaskets || [])

    const bItems = {
      sourceList: pItems,
    }
    pBaskets.forEach((x) => (bItems[x.id] = []))
    setItems(bItems)
  }, [pBaskets])

  const onDragEnd = (result) => {
    const { source, destination } = result

    // dropped outside the list
    if (!destination) {
      return
    }

    if (source.droppableId === destination.droppableId) {
      const newItems = reorder(
        items[source.droppableId],
        source.index,
        destination.index,
      )

      setItems({
        ...items,
        [source.droppableId]: newItems,
      })
    } else {
      const result = move(
        items[source.droppableId],
        items[destination.droppableId],
        source,
        destination,
      )

      console.log('!result~', result)

      setItems({
        ...items,
        [source.droppableId]: result[source.droppableId],
        [destination.droppableId]: result[destination.droppableId],
      })
    }
  }

  return (
    <>
      <p dangerouslySetInnerHTML={{ __html: title }} />

      <DragDropContext onDragEnd={onDragEnd}>
        <>
          <Droppable droppableId="sourceList" direction="horizontal">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {(items.sourceList || []).map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                        )}
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          <div className="basketsWrap">
            {baskets.map((x) => (
              <div className="basket" key={x.id}>
                <p>{x.title}</p>
                <Droppable droppableId={x.id} direction="horizontal">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={{
                        ...getListStyle(snapshot.isDraggingOver),
                        // margin: 10,
                        height: 200,
                      }}
                    >
                      {(items[x.id] || []).map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style,
                              )}
                              dangerouslySetInnerHTML={{ __html: item.content }}
                            />
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            ))}
          </div>
        </>
      </DragDropContext>
    </>
  )
}
